const safeIsNaN = (number) => Number.isNaN(Number(number))

export default safeIsNaN
